/**处理搜索参数**/
export const getProgIdAndNoticeSegmentTypeMaps = function (list, queryData) {
  let data = {};
  if (!queryData.types || queryData.types === "-1") {
    list.forEach((item) => {
      data[item.id] = [];
    });
    return data;
  }
  let keyList = queryData.types.split(",");
  let valData = queryData.noticeSegmentTypeStr.split(",");
  keyList.forEach((key) => {
    let item = list.find((i) => i.id === key);
    // let val=item.children.map(i=>  valData.includes(i.id))
    let val = valData
      .filter((i) => {
        if (item.children.filter((j) => j.id === i).length > 0) return i;
      })
      .map((i) => Number(i.toString().slice(-2)));
    data[key] = val;
  });
  return data;
};
/**处理集合参数
 * @param arr 需要处理的数据 []
 * @returns  {}
 */
export const getObjFromIdList = function (arr, idList) {
  var narr = {};
  for (var i = 0; i < arr.length; i++) {
    const item = arr[i];
    const children = item.children || [];
    if (idList.includes(Number(arr[i].id))) {
      narr[item.id] = [];
    } else {
      let intersectionSet = Array.from(
        new Set(children.filter((x) => idList.find((i) => i === x.id)))
      );
      if (intersectionSet.length > 0) {
        narr[item.id] = intersectionSet.map((i) => {
          return i.id;
        });
      }
    }
  }
  return narr;
};

/**根据key获取数据
 * @param list 需要从哪些数据提取
 * @param id  需要用哪些值，类型 字符串多个，分割
 * @returns  []
 */
export const getNameDataToId = function (list, id) {
  let val = id.split(",").map((i) => {
    return Number(i);
  });
  let n = [];
  list.forEach((item) => {
    if (val.includes(item.id)) {
      n.push({ id: item.id, name: item.text || item.name });
    }
    if (item.children) {
      item.children.forEach((i) => {
        if (val.includes(i.id)) {
          n.push({ pid: item.id, pname: item.text || item.name, ...i });
        }
      });
    }
  });
  return n;
};
